const minify = (str: string) => {
  return str.split("\n").join(" ");
};
export default minify;
